/* Ruggy deurmat-PDP.

   De pagina staat volledig in de HTML. Dit bestand werkt alleen bij na een
   keuze van kleur of maat, en dat gebeurt op één plek: render(). Prijs,
   sku, labels, hoofdbeeld, specificaties, de regel "Ook in", de kaarten bij
   Andere patronen en de URL lopen allemaal via die functie, zodat ze niet
   uit elkaar kunnen lopen.

   Daarnaast: de bestelknop (dezelfde route naar de winkelwagen als de
   vloeren-PDP), de terugbellade, de ankerbalk en de link "Meer info" die
   de retourvraag openklapt.

   Waarom de lade en de ankerbalk hier opnieuw staan: in solza-vloer-pdp.js
   zitten ze binnen de module die alleen op een vloer start (hij stopt
   zonder rekenhulp). Zelfde opmaak, zelfde gedrag, zie het opleververslag. */

(function () {
  'use strict';

  var wortel = document.querySelector('[data-solza-mat]');
  if (!wortel) return;

  function lees(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function alle(selector, binnen) {
    return Array.prototype.slice.call((binnen || document).querySelectorAll(selector));
  }

  var varianten = lees('[data-solza-mat-varianten]') || [];
  var teksten = lees('[data-solza-mat-teksten]') || {};
  var kaartdata = lees('[data-solza-mat-kaartdata]') || {};
  var kleurPos = parseInt(wortel.getAttribute('data-kleur-pos'), 10);
  var maatPos = parseInt(wortel.getAttribute('data-maat-pos'), 10);

  var idVeld = wortel.querySelector('[data-solza-mat-id]');
  var startId = idVeld ? parseInt(idVeld.value, 10) : 0;
  var huidig = varianten.filter(function (v) { return v.id === startId; })[0] || varianten[0];
  if (!huidig) return;

  var staat = {
    kleur: kleurPos >= 0 ? huidig.opties[kleurPos] : null,
    maat: maatPos >= 0 ? huidig.opties[maatPos] : null
  };

  function zoek(kleur, maat) {
    return varianten.filter(function (v) {
      return (kleurPos < 0 || v.opties[kleurPos] === kleur) && (maatPos < 0 || v.opties[maatPos] === maat);
    })[0] || null;
  }

  function zetTekst(selector, waarde) {
    alle(selector).forEach(function (el) { el.textContent = waarde; });
  }

  /* ---------- het hoofdbeeld ---------- */

  var stage = wortel.querySelector('[data-solza-mat-stage]');
  var galcap = wortel.querySelector('[data-solza-mat-galcap]');

  function toonBeeld(src, alt, mediaId) {
    if (!stage || !src) return;
    var img = stage.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'solza-mat__hoofdbeeld';
      stage.appendChild(img);
      stage.classList.remove('solza-mat__stage--leeg');
    }
    /* srcset van de server hoort bij het vorige beeld; weg ermee, anders
       kiest de browser daar nog uit. */
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.alt = alt || '';
    if (galcap) galcap.textContent = alt || '';
    alle('[data-solza-mat-thumb]', wortel).forEach(function (t) {
      t.setAttribute('aria-current', String(mediaId != null && t.getAttribute('data-solza-mat-thumb') === String(mediaId)));
    });
  }

  alle('[data-solza-mat-thumb]', wortel).forEach(function (t) {
    t.addEventListener('click', function () {
      toonBeeld(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-solza-mat-thumb'));
    });
  });

  /* ---------- de ene renderfunctie ---------- */

  function render(bijwerkenUrl) {
    var v = zoek(staat.kleur, staat.maat);

    alle('[data-solza-mat-kleur]', wortel).forEach(function (b) {
      var aan = b.getAttribute('data-solza-mat-kleur') === staat.kleur;
      b.setAttribute('aria-checked', String(aan));
      b.tabIndex = aan ? 0 : -1;
    });
    alle('[data-solza-mat-maat]', wortel).forEach(function (b) {
      var aan = b.getAttribute('data-solza-mat-maat') === staat.maat;
      b.setAttribute('aria-checked', String(aan));
      b.tabIndex = aan ? 0 : -1;
      /* De prijs per maat in de gekozen kleur. Vandaag gelijk voor alle
         kleuren, maar de knop leest het uit de variant en gaat niet uit
         van die gelijkheid. */
      var mv = zoek(staat.kleur, b.getAttribute('data-solza-mat-maat'));
      var p = b.querySelector('[data-solza-mat-maatprijs]');
      if (mv && p) p.textContent = mv.prijs_tekst;
    });

    zetTekst('[data-solza-mat-kleurnaam]', staat.kleur || '');
    zetTekst('[data-solza-mat-maatnaam]', staat.maat || '');
    zetTekst('[data-solza-mat-ookkleur]', staat.kleur || '');
    zetTekst('[data-solza-mat-spec="kleur"]', staat.kleur || '');
    zetTekst('[data-solza-mat-spec="maat"]', staat.maat || '');

    var knop = wortel.querySelector('[data-solza-mat-knop]');
    var knopTekst = wortel.querySelector('[data-solza-mat-knoptekst]');

    if (!v) {
      if (knop) knop.disabled = true;
      if (knopTekst) knopTekst.textContent = teksten.niet_leverbaar || '';
      return;
    }

    huidig = v;
    if (idVeld) idVeld.value = v.id;
    zetTekst('[data-solza-mat-prijs]', v.prijs_tekst);
    zetTekst('[data-solza-mat-sku]', v.sku || '');
    zetTekst('[data-solza-mat-spec="sku"]', v.sku || '');
    if (knop) knop.disabled = !v.beschikbaar;
    if (knopTekst) knopTekst.textContent = v.beschikbaar ? teksten.knop : teksten.niet_leverbaar;

    if (v.beeld) toonBeeld(v.beeld, v.beeld_alt, v.media);

    /* De kaarten bij Andere patronen: beeld, link en kleurregel in de
       gekozen kleur, uit de JSON in die sectie. */
    alle('[data-solza-mat-kaart]').forEach(function (kaart) {
      var data = kaartdata[kaart.getAttribute('data-solza-mat-kaart')];
      var k = data && data[staat.kleur];
      if (!k) return;
      alle('[data-solza-mat-kaart-link]', kaart).forEach(function (a) { a.href = k.url; });
      var regel = kaart.querySelector('[data-solza-mat-kaart-kleur]');
      if (regel) regel.textContent = k.regel;
      var beeldLink = kaart.querySelector('.solza-mat-kaart__beeld');
      if (beeldLink) {
        var img = beeldLink.querySelector('img');
        if (k.beeld) {
          if (!img) {
            img = document.createElement('img');
            img.loading = 'lazy';
            beeldLink.appendChild(img);
          }
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = k.beeld;
          img.alt = k.alt || '';
        } else if (img) {
          img.remove();
        }
      }
    });

    if (bijwerkenUrl && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---------- kiezen ---------- */

  /* Radiogroep-gedrag: klik kiest, pijltjestoetsen gaan naar de volgende
     of vorige keuze en kiezen die meteen (zoals bij native radio's). */
  function radiogroep(selector, attribuut, sleutel) {
    var knoppen = alle(selector, wortel);
    knoppen.forEach(function (b, i) {
      b.addEventListener('click', function () {
        staat[sleutel] = b.getAttribute(attribuut);
        render(true);
      });
      b.addEventListener('keydown', function (e) {
        var stap = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') stap = 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') stap = -1;
        if (!stap) return;
        e.preventDefault();
        var volgende = knoppen[(i + stap + knoppen.length) % knoppen.length];
        staat[sleutel] = volgende.getAttribute(attribuut);
        render(true);
        volgende.focus();
      });
    });
  }

  radiogroep('[data-solza-mat-kleur]', 'data-solza-mat-kleur', 'kleur');
  radiogroep('[data-solza-mat-maat]', 'data-solza-mat-maat', 'maat');

  /* ---------- winkelwagen ---------- */

  var formulier = wortel.querySelector('.solza-mat__form');
  var fout = wortel.querySelector('[data-solza-mat-fout]');

  function toonFout(bericht) {
    if (!fout) return;
    fout.textContent = bericht;
    fout.hidden = false;
  }

  /* Eigen event, met dezelfde opzet als solza_vloer_add_to_cart. De oude
     oid_add_to_cart slaat deze knop over (data-solza-bestelknop), dus er
     telt niets dubbel. */
  function meld(regel) {
    if (!window.dataLayer || !regel) return;
    window.dataLayer.push({
      event: 'solza_mat_add_to_cart',
      pageType: 'Product',
      ecommerce: {
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || undefined,
        value: (regel.final_line_price || regel.line_price || 0) / 100,
        items: [{
          item_id: regel.sku || huidig.sku,
          item_name: regel.product_title,
          item_brand: regel.vendor,
          item_variant: [staat.kleur, staat.maat].filter(Boolean).join(' / '),
          price: (regel.final_price || regel.price || 0) / 100,
          quantity: 1
        }]
      }
    });
  }

  if (formulier) {
    formulier.addEventListener('submit', function (e) {
      if (typeof window.fetchConfig !== 'function' || !window.MinimogSettings) return;
      e.preventDefault();
      if (fout) fout.hidden = true;

      var knop = wortel.querySelector('[data-solza-mat-knop]');
      var knopTekst = wortel.querySelector('[data-solza-mat-knoptekst]');
      var lade = document.querySelector('m-cart-drawer');
      var body = { items: [{ id: huidig.id, quantity: 1 }] };
      if (lade && typeof lade.getSectionsToRender === 'function') {
        body.sections = lade.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      var config = window.fetchConfig('javascript');
      config.method = 'POST';
      config.body = JSON.stringify(body);

      if (knop) knop.disabled = true;
      if (knopTekst) knopTekst.textContent = teksten.knop_bezig || '';

      fetch(window.MinimogSettings.routes.cart_add_url, config)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            toonFout(data.description || teksten.fout);
            return;
          }
          meld(data.items && data.items[0]);
          if (!window.MinimogSettings.use_ajax_atc) {
            window.location = window.MinimogSettings.routes.cart;
            return;
          }
          if (window.MinimogSettings.enable_cart_drawer && lade) lade.renderContents(data);
          if (window.MinimogEvents && window.MinimogTheme) {
            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
          }
        })
        .catch(function () {
          toonFout(teksten.fout);
        })
        .finally(function () {
          if (knop) knop.disabled = !huidig.beschikbaar;
          if (knopTekst) knopTekst.textContent = teksten.knop || '';
        });
    });
  }

  /* ---------- terugbellade ---------- */

  var lade = document.getElementById('solza-lade');
  var ladeTitel = document.getElementById('solza-lade-titel');
  var laatsteOpener = null;

  function ladeOpen(sleutel, opener) {
    if (!lade) return false;
    var paneel = lade.querySelector('[data-solza-lade-paneel="' + sleutel + '"]');
    if (!paneel) return false;
    alle('[data-solza-lade-paneel]', lade).forEach(function (p) { p.hidden = p !== paneel; });
    if (ladeTitel) ladeTitel.textContent = paneel.dataset.titel || '';
    lade.hidden = false;
    var waas = document.querySelector('.solza-lade-waas');
    if (waas) waas.hidden = false;
    document.body.style.overflow = 'hidden';
    laatsteOpener = opener || null;
    var sluit = lade.querySelector('.solza-lade__sluit');
    if (sluit) sluit.focus();
    return true;
  }

  function ladeDicht() {
    if (!lade || lade.hidden) return;
    lade.hidden = true;
    var waas = document.querySelector('.solza-lade-waas');
    if (waas) waas.hidden = true;
    document.body.style.overflow = '';
    if (laatsteOpener && document.contains(laatsteOpener)) laatsteOpener.focus();
    laatsteOpener = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-solza-lade-open]');
    if (opener) {
      /* Lukt openen niet (geen paneel), dan volgt de link gewoon zijn
         href naar de adviesband. */
      if (ladeOpen(opener.dataset.solzaLadeOpen, opener)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-solza-lade-sluit]')) ladeDicht();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') ladeDicht();
  });

  /* ---------- "Meer info": naar de retourvraag en openklappen ---------- */

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-solza-mat-faq-open]');
    if (!link) return;
    var doel = document.getElementById(link.getAttribute('data-solza-mat-faq-open'));
    if (!doel) return;
    var trigger = doel.querySelector('.solza-acc__trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
  });

  /* ---------- ankerbalk ----------
     Zelfde regels als op de vloeren-PDP: een anker zonder band gaat uit de
     balk, en de actieve band volgt de scrollpositie (setTimeout-throttle,
     geen IntersectionObserver: op deze winkel scrollt de body). */

  var ankerbalk = document.querySelector('[data-solza-ankers]');
  if (ankerbalk) {
    var doelen = [];
    alle('[data-solza-anker]', ankerbalk).forEach(function (anker) {
      var doel = document.getElementById(anker.dataset.solzaAnker);
      if (!doel) {
        anker.remove();
        return;
      }
      doelen.push({ anker: anker, doel: doel });
    });

    if (!doelen.length) {
      ankerbalk.remove();
    } else {
      var wachtend = false;
      var bepaalActief = function () {
        wachtend = false;
        var grens = 140;
        var actief = null;
        doelen.forEach(function (paar) {
          var vak = paar.doel.getBoundingClientRect();
          if (vak.top <= grens && vak.bottom > grens) actief = paar;
        });
        doelen.forEach(function (paar) {
          paar.anker.classList.toggle('is-actief', paar === actief);
        });
      };
      var plan = function () {
        if (wachtend) return;
        wachtend = true;
        window.setTimeout(bepaalActief, 100);
      };
      document.addEventListener('scroll', plan, { passive: true, capture: true });
      window.addEventListener('resize', plan, { passive: true });
      bepaalActief();
    }
  }

  render(false);
})();
